import type { PageContext } from '@models';
import { defaultLocale } from '@helpers/shared/common';

export interface PageState extends PageContext {
    isLivePreview: boolean;
}

export const initialPageState: PageState = {
    slug: '',
    locale: defaultLocale,
    id: '',
    isLivePreview: false,
};
